module.exports = __webpack_public_path__ + "img/second_icon_jiashichangshi@2x.de6402ad.png";